(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  /**
   * Share rail visibility, the copy button, the native share sheet and the
   * scroll reveals.
   */
  class ArticlePage extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const body = this.querySelector('.art__body');

      // Tells the stylesheet it is allowed to hide things before revealing
      // them. Without this class every [data-reveal] element stays visible,
      // so a script failure costs an animation rather than the content.
      this.classList.add('is-js');

      const motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /**
       * The rail appears once the body copy is in view and goes again at the
       * comments. Share controls hovering beside the footer are clutter: the
       * reader has already left the article.
       */
      const share = this.querySelector('[data-share]');
      if (share && body && 'IntersectionObserver' in window) {
        this.shareObserver = new IntersectionObserver(
          ([entry]) => share.classList.toggle('is-visible', entry.isIntersecting),
          { rootMargin: '-120px 0px -40% 0px', threshold: 0 }
        );
        this.shareObserver.observe(body);
      }

      this.setUpReveals(motionOK);
      this.setUpCopy(signal);
      this.setUpNativeShare(signal);
    }

    /** Fade-and-rise as each marked element arrives. Runs once per element. */
    setUpReveals(motionOK) {
      const targets = this.querySelectorAll('[data-reveal]');
      if (!targets.length) return;

      if (!motionOK || !('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-in'));
        return;
      }

      this.revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.06 }
      );

      targets.forEach((el) => {
        // Anything already on screen at load should not animate in — it would
        // flash after the reader is looking at it.
        if (el.getBoundingClientRect().top < window.innerHeight * 0.9) {
          el.classList.add('is-in');
        } else {
          this.revealObserver.observe(el);
        }
      });
    }

    setUpCopy(signal) {
      const copy = this.querySelector('[data-copy-link]');
      if (!copy || !navigator.clipboard) return;

      const tip = copy.dataset.tip;
      const label = copy.querySelector('.visually-hidden');
      const original = label ? label.textContent : '';

      copy.addEventListener(
        'click',
        () => {
          navigator.clipboard.writeText(window.location.href).then(() => {
            // Swap the tooltip text as well as the glyph, so the confirmation
            // is visible whether the reader is on a pointer or a keyboard.
            copy.dataset.tip = copy.dataset.copied;
            copy.classList.add('is-copied');
            if (label) label.textContent = copy.dataset.copied;

            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
              copy.classList.remove('is-copied');
              copy.dataset.tip = tip;
              if (label) label.textContent = original;
            }, 2000);
          });
        },
        { signal }
      );
    }

    /**
     * The OS share sheet, where it exists. Revealed rather than created so the
     * button's markup and translations stay in Liquid.
     */
    setUpNativeShare(signal) {
      const button = this.querySelector('[data-native-share]');
      if (!button || !navigator.share) return;

      button.hidden = false;
      button.addEventListener(
        'click',
        () => {
          // A cancelled sheet rejects. That is the reader saying no, not an
          // error worth reporting.
          navigator
            .share({ title: button.dataset.shareTitle || document.title, url: window.location.href })
            .catch(() => {});
        },
        { signal }
      );
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.shareObserver) this.shareObserver.disconnect();
      if (this.revealObserver) this.revealObserver.disconnect();
      clearTimeout(this.copyTimer);
    }
  }

  if (!customElements.get('article-page')) {
    customElements.define('article-page', ArticlePage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /**
   * Submits the cart form when a quantity changes, and hides the manual update
   * button that exists for the no-JavaScript path.
   */
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.controller = new AbortController();

      const manual = this.querySelector('[data-manual-update]');
      if (manual) manual.hidden = true;

      this.form.addEventListener(
        'change',
        (event) => {
          if (!event.target.matches('[data-auto-submit]')) return;

          // A quantity of zero is a removal, so it is passed through rather
          // than clamped — that is what the customer typed.
          if (this.form.requestSubmit) {
            this.form.requestSubmit();
          } else {
            this.form.submit();
          }
        },
        { signal: this.controller.signal }
      );
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /**
   * Progressive enhancement for the filter and sort form.
   *
   * Without this element the form still works: every control is a named input
   * and the Apply button submits normally. The element hides that button,
   * submits on change instead, and manages the drawer's open state.
   */
  class FacetForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.drawer = this.querySelector('[data-drawer]');
      this.toggle = this.querySelector('[data-drawer-open]');
      this.applyButton = this.querySelector('[data-apply]');
      this.doneButton = this.querySelector('[data-drawer-done]');
      this.controller = new AbortController();

      const { signal } = this.controller;

      // Submitting on change makes a manual apply redundant. The Done button
      // takes its place so the drawer still has an obvious way out on a phone.
      if (this.applyButton) this.applyButton.hidden = true;
      if (this.doneButton) this.doneButton.style.display = 'block';

      this.form.addEventListener(
        'change',
        (event) => {
          if (!event.target.matches('[data-auto-submit]')) return;
          this.markBusy();
          this.form.submit();
        },
        { signal }
      );

      if (this.toggle && this.drawer) {
        this.toggle.addEventListener('click', () => this.open(), { signal });

        this.querySelectorAll('[data-drawer-close]').forEach((button) => {
          button.addEventListener('click', () => this.close(), { signal });
        });

        document.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'Escape' && !this.drawer.hidden) this.close();
          },
          { signal }
        );
      }
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.scrim) this.scrim.remove();
      document.documentElement.style.overflow = '';
    }

    /* Dims the grid so a slow filter request doesn't look like a dead click. */
    markBusy() {
      const grid = document.querySelector('[data-grid]');
      if (grid) grid.setAttribute('aria-busy', 'true');
    }

    open() {
      this.drawer.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';

      this.scrim = document.createElement('div');
      this.scrim.className = 'facets__scrim';
      this.scrim.addEventListener('click', () => this.close());
      // Kept inside this element so it shares the drawer's stacking context.
      this.appendChild(this.scrim);

      const first = this.drawer.querySelector('input, select, button');
      if (first) first.focus();
    }

    close() {
      this.drawer.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if (this.scrim) this.scrim.remove();
      this.toggle.focus();
    }
  }

  if (!customElements.get('facet-form')) {
    customElements.define('facet-form', FacetForm);
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  /**
   * Counts down to the ISO 8601 timestamp in data-end.
   *
   * Guards against the two failure modes of the original inline script:
   * a null document.currentScript when the bundle is deferred, and stacked
   * setInterval timers when the theme editor re-renders the section.
   */
  class CountdownBar extends HTMLElement {
    connectedCallback() {
      this.clock = this.querySelector('[data-countdown]');
      this.expiredEl = this.querySelector('[data-expired]');
      this.endTime = Date.parse(this.dataset.end);

      // An unparseable or missing date leaves the bar's other content intact.
      if (!this.clock || Number.isNaN(this.endTime)) return;

      this.units = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };

      this.clock.hidden = false;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = Math.max(0, Math.floor((this.endTime - Date.now()) / 1000));

      if (remaining === 0) {
        clearInterval(this.timer);
        this.expire();
        return;
      }

      const pad = (n) => String(n).padStart(2, '0');
      this.units.days.textContent = pad(Math.floor(remaining / 86400));
      this.units.hours.textContent = pad(Math.floor((remaining % 86400) / 3600));
      this.units.minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
      this.units.seconds.textContent = pad(remaining % 60);
    }

    expire() {
      if (this.hasAttribute('data-hide-when-expired')) {
        this.hidden = true;
        return;
      }

      this.clock.hidden = true;
      if (this.expiredEl) this.expiredEl.hidden = false;
    }
  }

  if (!customElements.get('countdown-bar')) {
    customElements.define('countdown-bar', CountdownBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  /**
   * Arrow controls for a horizontally scrolling row.
   *
   * The row scrolls natively by touch, trackpad and keyboard without this — the
   * arrows are pointer affordances only, so they stay hidden until there is
   * actually something to scroll to.
   */
  class ScrollRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.controller = new AbortController();

      const { signal } = this.controller;

      if (this.prev) this.prev.addEventListener('click', () => this.step(-1), { signal });
      if (this.next) this.next.addEventListener('click', () => this.step(1), { signal });

      this.track.addEventListener('scroll', () => this.update(), { signal, passive: true });

      // Card widths are a function of container width, so remeasure on resize.
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);

      this.update();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    step(direction) {
      const card = this.track.querySelector('li');
      if (!card) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = card.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const overflows = scrollWidth - clientWidth > 4;

      if (this.prev) this.prev.hidden = !overflows || scrollLeft <= 4;
      if (this.next) this.next.hidden = !overflows || scrollLeft >= scrollWidth - clientWidth - 4;
    }
  }

  if (!customElements.get('scroll-row')) {
    customElements.define('scroll-row', ScrollRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Toggles a drop shadow on the section wrapper once the header sticks.
   *
   * The observer watches the wrapper for a ratio below 1, which only happens
   * once its `top: -1px` offset pushes it a pixel past the viewport edge.
   */
  class StoreHeader extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.shopify-section');
      if (!this.wrapper) return;

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.wrapper.classList.toggle('is-stuck', entry.intersectionRatio < 1);
        },
        { threshold: [1] }
      );

      this.observer.observe(this.wrapper);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('store-header')) {
    customElements.define('store-header', StoreHeader);
  }

  /**
   * Suggestions from Shopify's own /search/suggest.json.
   *
   * Every behaviour here is additive: the wrapped form is a real GET form with
   * a real action, so with scripts blocked, or if the endpoint fails, pressing
   * Enter still lands on the search page. That is also the failure path — a
   * fetch error clears the panel rather than showing an error, because the
   * shopper already has a working way to search.
   */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-predictive-input]');
      this.panel = this.querySelector('[data-predictive-panel]');
      if (!this.input || !this.panel) return;

      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.timer = null;
      this.inflight = null;
      this.index = -1;

      // Announced only now that there is something to announce.
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.panel.setAttribute('role', 'listbox');

      this.input.addEventListener('input', () => this.schedule(), { signal });
      this.input.addEventListener('focus', () => this.schedule(), { signal });
      this.input.addEventListener('keydown', (e) => this.onKeydown(e), { signal });

      /**
       * Prevent the browser from auto-scrolling the page when the search
       * input (inside the sticky header) receives focus or is typed into.
       *
       * The browser sees the input inside a sticky element at top:-1px and
       * keeps trying to "scroll it into view" on every DOM change (panel
       * show/hide). We lock the scroll position while the input is focused
       * and release it on blur.
       */
      this._scrollLockY = null;
      this._onScrollLock = () => {
        if (this._scrollLockY !== null) {
          window.scrollTo({ top: this._scrollLockY, behavior: 'instant' });
        }
      };

      this.input.addEventListener('focus', () => {
        this._scrollLockY = window.scrollY;
        window.addEventListener('scroll', this._onScrollLock);
      }, { signal });

      this.input.addEventListener('blur', () => {
        window.removeEventListener('scroll', this._onScrollLock);
        this._scrollLockY = null;
      }, { signal });

      /**
       * The expand/collapse pair only exists below the header's breakpoint;
       * above it the field is always visible and these are display:none, so
       * the listeners are harmless either way.
       */
      this.toggle = this.querySelector('[data-search-toggle]');
      if (this.toggle) {
        this.toggle.addEventListener('click', () => this.expand(), { signal });
      }

      const closer = this.querySelector('[data-search-close]');
      if (closer) {
        closer.addEventListener('click', () => this.collapse(), { signal });
      }

      document.addEventListener(
        'click',
        (event) => {
          if (this.contains(event.target)) return;
          this.hide();
          this.collapse();
        },
        { signal }
      );
    }

    expand() {
      this.classList.add('is-open');
      if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');

      // Focus after the class lands, or the field is still display:none and
      // the browser has nothing to focus. preventScroll stops the browser
      // from yanking the page to the top of the sticky header.
      requestAnimationFrame(() => this.input.focus({ preventScroll: true }));
    }

    collapse() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      if (this.toggle) {
        this.toggle.setAttribute('aria-expanded', 'false');

        // Focus goes back to the control that opened it rather than to the
        // top of the document.
        this.toggle.focus({ preventScroll: true });
      }
      this.hide();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.inflight) this.inflight.abort();
      clearTimeout(this.timer);
    }

    /**
     * Debounced, and each request aborts the one before it. Without the abort
     * a slow response for "cle" can land after the fast one for "cleaner" and
     * overwrite it with staler results.
     */
    schedule() {
      clearTimeout(this.timer);
      const term = this.input.value.trim();
      if (term.length < 2) return this.hide();
      this.timer = setTimeout(() => this.search(term), 220);
    }

    search(term) {
      if (this.inflight) this.inflight.abort();
      this.inflight = new AbortController();

      // Only when the panel is not already showing results: repainting a
      // populated dropdown as dots on every keystroke is worse than a brief
      // stale result.
      if (this.panel.hidden) {
        this.panel.innerHTML =
          '<div class="psearch__loading"><span></span><span></span><span></span></div>';
        this.show();
      }

      const url =
        '/search/suggest.json?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product,collection,page&resources[limit]=5' +
        '&resources[options][unavailable_products]=last';

      fetch(url, { signal: this.inflight.signal, headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((data) => this.render(data.resources.results))
        .catch((error) => {
          if (error.name !== 'AbortError') this.hide();
        });
    }

    render(results) {
      const groups = [
        ['products', results.products || []],
        ['collections', results.collections || []],
        ['pages', results.pages || []],
      ].filter(([, items]) => items.length);

      if (!groups.length) {
        this.panel.innerHTML =
          '<p class="psearch__empty">' + (this.dataset.noResults || '') + '</p>';
        this.show();
        return;
      }

      this.panel.innerHTML = groups
        .map(
          ([name, items]) =>
            '<div class="psearch__group"><p class="psearch__label">' +
            name +
            '</p>' +
            items
              .map((item) => {
                const thumb = item.featured_image && item.featured_image.url
                  ? '<img class="psearch__thumb" src="' +
                    item.featured_image.url +
                    '" alt="" width="40" height="40" loading="lazy">'
                  : '';
                const price = item.price
                  ? '<p class="psearch__price">' +
                    (this.dataset.currency || '') +
                    item.price +
                    '</p>'
                  : '';
                return (
                  '<a class="psearch__item" role="option" href="' +
                  item.url +
                  '">' +
                  thumb +
                  '<span class="psearch__text"><span class="psearch__name">' +
                  item.title +
                  '</span>' +
                  price +
                  '</span></a>'
                );
              })
              .join('') +
            '</div>'
        )
        .join('');

      this.index = -1;
      this.show();
    }

    get items() {
      return Array.from(this.panel.querySelectorAll('.psearch__item'));
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.hide();
        this.collapse();
        return;
      }
      if (this.panel.hidden) return;

      const items = this.items;
      if (!items.length) return;

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        this.index = (this.index + step + items.length) % items.length;
        items.forEach((el, i) => el.classList.toggle('is-active', i === this.index));
        
        const activeItem = items[this.index];
        const panel = this.panel;
        if (activeItem.offsetTop < panel.scrollTop) {
          panel.scrollTop = activeItem.offsetTop;
        } else if (activeItem.offsetTop + activeItem.offsetHeight > panel.scrollTop + panel.offsetHeight) {
          panel.scrollTop = activeItem.offsetTop + activeItem.offsetHeight - panel.offsetHeight;
        }
        return;
      }

      // Enter with nothing highlighted falls through to the form, which is the
      // full search results page — the right destination for a broad query.
      if (event.key === 'Enter' && this.index > -1) {
        event.preventDefault();
        items[this.index].click();
      }
    }

    show() {
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    hide() {
      this.panel.hidden = true;
      this.index = -1;
      this.input.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  /**
   * Split hero carousel.
   *
   * Every listener is registered against an AbortController so that
   * disconnectedCallback tears the whole thing down in one call — important in
   * the theme editor, which repeatedly removes and re-inserts the section.
   */
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length === 0) return;

      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.liveRegion = this.querySelector('[data-live]');
      this.pauseButton = this.querySelector('[data-pause]');
      this.index = 0;
      this.timer = null;
      this.userPaused = false;
      this.controller = new AbortController();

      const { signal } = this.controller;
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplays = this.hasAttribute('data-autoplay') && !reduceMotion.matches;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.goTo(i), { signal });
      });

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.goTo(this.index - 1), { signal });
      this.querySelector('[data-next]')?.addEventListener('click', () => this.goTo(this.index + 1), { signal });
      this.pauseButton?.addEventListener('click', () => this.togglePause(), { signal });

      // Hover and focus pause are conveniences; the button is the real control.
      this.addEventListener('mouseenter', () => this.suspend(), { signal });
      this.addEventListener('mouseleave', () => this.resume(), { signal });
      this.addEventListener('focusin', () => this.suspend(), { signal });
      this.addEventListener('focusout', () => this.resume(), { signal });

      document.addEventListener(
        'visibilitychange',
        () => (document.hidden ? this.suspend() : this.resume()),
        { signal }
      );

      this.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'ArrowLeft') {
            this.goTo(this.index - 1);
            event.preventDefault();
          }
          if (event.key === 'ArrowRight') {
            this.goTo(this.index + 1);
            event.preventDefault();
          }
        },
        { signal }
      );

      let startX = null;
      this.addEventListener('pointerdown', (event) => { startX = event.clientX; }, { signal });
      this.addEventListener(
        'pointerup',
        (event) => {
          if (startX === null) return;
          const dx = event.clientX - startX;
          if (Math.abs(dx) > 45) this.goTo(this.index + (dx < 0 ? 1 : -1));
          startX = null;
        },
        { signal }
      );

      // Theme editor: jump to whichever slide the merchant is editing.
      this.addEventListener('shopify:block:select', (event) => {
        const target = this.slides.indexOf(event.target.closest('[data-slide]'));
        if (target > -1) {
          this.goTo(target);
          this.suspend();
        }
      }, { signal });

      this.addEventListener('shopify:block:deselect', () => this.resume(), { signal });

      this.goTo(0, { announce: false });
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }

    goTo(next, { announce = true } = {}) {
      const total = this.slides.length;
      this.index = ((next % total) + total) % total;

      this.slides.forEach((slide, i) => {
        const isActive = i === this.index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));

        const video = slide.querySelector('video');
        if (!video) return;

        if (isActive) {
          video.play().catch(() => {
            /* Autoplay refused; the duration timer takes over. */
          });
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });

      this.dots.forEach((dot, i) => {
        if (i === this.index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (announce && this.liveRegion) {
        this.liveRegion.textContent = this.slides[this.index].getAttribute('aria-label') || '';
      }

      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (!this.autoplays || this.userPaused || this.classList.contains('is-paused')) return;

      const slide = this.slides[this.index];
      const video = slide.querySelector('video');
      const seconds = Number(slide.dataset.duration) || 7;

      // Restart the progress animation on the active dot.
      const dot = this.dots[this.index];
      if (dot) {
        dot.style.setProperty('--duration', `${seconds}s`);
        void dot.offsetWidth;
      }

      // A video advances when its clip ends, but `ended` never fires if autoplay
      // was refused or the file failed to decode — which would strand the
      // carousel on that slide. So a timer always runs as a safety net, sized to
      // the clip when its duration is known.
      let fallbackSeconds = seconds;

      if (video) {
        video.onended = () => this.goTo(this.index + 1);
        if (Number.isFinite(video.duration) && video.duration > 0) {
          fallbackSeconds = video.duration + 0.5;
        }
      }

      this.timer = setTimeout(() => this.goTo(this.index + 1), fallbackSeconds * 1000);
    }

    suspend() {
      this.classList.add('is-paused');
      clearTimeout(this.timer);
    }

    resume() {
      if (this.userPaused) return;
      this.classList.remove('is-paused');
      this.schedule();
    }

    togglePause() {
      this.userPaused = !this.userPaused;
      this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));

      const label = this.pauseButton.querySelector('[data-pause-label]');
      if (label) {
        const next = this.userPaused
          ? this.pauseButton.dataset.playText
          : this.pauseButton.dataset.pauseText;
        if (next) label.textContent = next;
      }

      if (this.userPaused) {
        this.suspend();
      } else {
        this.classList.remove('is-paused');
        this.schedule();
      }
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-nav"]) return;
  try {
    
  /**
   * Mobile navigation drawer.
   *
   * The trigger ships with the `hidden` attribute and is revealed here, so a
   * shopper whose scripts failed never sees a button that does nothing — the
   * horizontal strip of top-level links is still there and still works.
   *
   * The panel is a modal <dialog>, which makes Escape, the backdrop and the
   * focus trap the browser's job rather than this file's. What is left is the
   * slide animation and keeping aria-expanded honest however it was closed.
   */
  class NavMenu extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-menu]');
      // Look globally for the trigger since it was moved to the header section
      this.trigger = document.querySelector('[data-menu-open]');
      if (!this.drawer || !this.trigger || typeof this.drawer.showModal !== 'function') return;

      this.controller = new AbortController();
      const { signal } = this.controller;

      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => this.open(), { signal });

      this.querySelectorAll('[data-menu-close]').forEach((button) => {
        button.addEventListener('click', () => this.close(), { signal });
      });

      // A click on the backdrop reports the dialog itself as the target.
      this.drawer.addEventListener(
        'click',
        (event) => {
          if (event.target === this.drawer) this.close();
        },
        { signal }
      );

      // Fires for Escape too, so the trigger's state stays correct.
      this.drawer.addEventListener(
        'close',
        () => {
          this.drawer.classList.remove('is-open');
          this.trigger.setAttribute('aria-expanded', 'false');
        },
        { signal }
      );

      // Resizing to desktop would leave an open drawer stranded to one side.
      this.desktop = window.matchMedia('(min-width: 901px)');
      this.desktop.addEventListener(
        'change',
        (event) => {
          if (event.matches && this.drawer.open) this.drawer.close();
        },
        { signal }
      );
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.drawer && this.drawer.open) this.drawer.close();
    }

    open() {
      this.drawer.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');

      // A frame between opening and animating, or the transition never runs.
      requestAnimationFrame(() => this.drawer.classList.add('is-open'));
    }

    close() {
      this.drawer.classList.remove('is-open');
      setTimeout(() => {
        if (this.drawer.open) this.drawer.close();
      }, 260);
    }
  }

  if (!customElements.get('nav-menu')) {
    customElements.define('nav-menu', NavMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about"]) return;
  try {
    
  /** Scroll reveals for the about page. */
  class AboutPage extends HTMLElement {
    connectedCallback() {
      this.classList.add('is-js');

      const targets = this.querySelectorAll('[data-reveal]');
      if (!targets.length) return;

      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (still || !('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-in'));
        return;
      }

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
      );

      targets.forEach((el) => {
        // Anything already on screen when the page loads is shown at once.
        // Animating it in would flash under a reader already looking at it,
        // and on the first item it would delay the largest paint.
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
          el.classList.add('is-in');
        } else {
          this.observer.observe(el);
        }
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('about-page')) {
    customElements.define('about-page', AboutPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"]) return;
  try {
    
  if (!customElements.get('contact-form')) {
    customElements.define(
      'contact-form',
      class ContactForm extends HTMLElement {
        connectedCallback() {
          // After a successful post the section re-renders with only the
          // confirmation. Move focus to it so a screen reader announces the
          // result instead of dropping the user back at the top of the page.
          const success = this.querySelector('[data-success]');
          if (success) {
            requestAnimationFrame(() => success.focus());
            return;
          }

          this.form = this.closest('form');
          if (!this.form) return;

          this.trap = this.querySelector('.cform__trap input');
          this.consent = this.querySelector('.cform__checkbox');
          this.consentRow = this.querySelector('.cform__consent');
          this.submitButton = this.querySelector('.cform__submit');
          this.sending = false;

          this.onSubmit = this.onSubmit.bind(this);
          this.form.addEventListener('submit', this.onSubmit);

          if (this.consent) {
            // `invalid` fires when the browser blocks submission. Colour the
            // row so the reason is visible even if the native bubble is
            // missed or dismissed.
            this.consent.addEventListener('invalid', () => {
              if (this.consentRow) this.consentRow.classList.add('is-missing');
            });
            this.consent.addEventListener('change', () => {
              if (this.consentRow) this.consentRow.classList.remove('is-missing');
            });
          }
        }

        disconnectedCallback() {
          if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        }

        onSubmit(event) {
          // Honeypot: a human never sees this field, so anything in it came
          // from something filling every input on the page.
          if (this.trap && this.trap.value !== '') {
            event.preventDefault();
            return;
          }

          // Stop a second submission while the first is in flight. Without
          // this an impatient double-click sends two identical enquiries.
          if (this.sending) {
            event.preventDefault();
            return;
          }

          this.sending = true;
          if (this.submitButton) this.submitButton.setAttribute('aria-disabled', 'true');

          // If the browser blocks the submit for a validation error the page
          // never navigates, so release the lock again.
          setTimeout(() => {
            this.sending = false;
            if (this.submitButton) this.submitButton.removeAttribute('aria-disabled');
          }, 6000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-policy"]) return;
  try {
    
  /**
   * Builds the table of contents from the headings already in the page and
   * highlights whichever section is currently on screen.
   *
   * Derived rather than hand-maintained: a merchant editing the policy text
   * would otherwise have to remember to update a second list of links, and the
   * two would drift apart the first time they didn't.
   */
  class PolicyPage extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-content]');
      this.toc = this.querySelector('[data-toc]');
      this.list = this.querySelector('[data-toc-list]');
      if (!this.content || !this.toc || !this.list) return;

      this.headings = Array.from(this.content.querySelectorAll('h2'));

      // One or two headings isn't a document worth navigating.
      if (this.headings.length < 3) return;

      const used = new Set();

      this.headings.forEach((heading, index) => {
        if (!heading.id) {
          // Shopify's rich text editor strips ids, so derive a stable one.
          const base =
            heading.textContent
              .toLowerCase()
              .trim()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-|-$/g, '') || `section-${index + 1}`;

          let id = base;
          let n = 2;
          while (used.has(id) || document.getElementById(id)) {
            id = `${base}-${n}`;
            n += 1;
          }
          heading.id = id;
        }

        used.add(heading.id);

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.appendChild(link);
        this.list.appendChild(item);
      });

      this.links = Array.from(this.list.querySelectorAll('a'));
      this.toc.hidden = false;

      // Collapsed on a phone, where the index would push the policy itself off
      // the first screen; always open on desktop, where it has its own column.
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.syncToc = () => {
        this.toc.open = this.desktop.matches;
      };
      this.syncToc();
      this.desktop.addEventListener('change', this.syncToc);

      /**
       * The top band stops the active item flipping while a heading is still
       * under the sticky chrome. Read from the same custom property the chrome
       * itself is positioned with, so the two cannot drift apart.
       */
      const offset =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue('--sticky-offset'),
          10
        ) || 90;

      this.observer = new IntersectionObserver(
        (entries) => this.onIntersect(entries),
        { rootMargin: `-${offset + 24}px 0px -70% 0px`, threshold: 0 }
      );

      this.headings.forEach((heading) => this.observer.observe(heading));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.desktop && this.syncToc) this.desktop.removeEventListener('change', this.syncToc);
    }

    onIntersect(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        this.links.forEach((link) => {
          const active = link.getAttribute('href') === `#${entry.target.id}`;
          if (active) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      });
    }
  }

  if (!customElements.get('policy-page')) {
    customElements.define('policy-page', PolicyPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-wishlist"]) return;
  try {
    
  /**
   * Renders the saved wishlist by fetching each product's card section.
   */
  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.empty = this.querySelector('[data-empty]');
      this.loading = this.querySelector('[data-loading]');
      this.clear = this.querySelector('[data-clear]');
      this.template = this.dataset.cardUrl;

      this.controller = new AbortController();

      if (this.clear) {
        this.clear.addEventListener(
          'click',
          () => {
            localStorage.removeItem('wishlist');
            document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handles: [] } }));
            this.render();
          },
          { signal: this.controller.signal }
        );
      }

      // Removing an item from its own card should update this page immediately.
      document.addEventListener('wishlist:change', () => this.render(), {
        signal: this.controller.signal,
      });

      this.render();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }

    get handles() {
      try {
        const parsed = JSON.parse(localStorage.getItem('wishlist') || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    async render() {
      const handles = this.handles;

      if (handles.length === 0) {
        this.updateCount(0);
        this.show(this.empty);
        return;
      }

      // Cards are fetched in parallel; a single slow product shouldn't hold
      // the whole grid.
      const results = await Promise.all(
        handles.map(async (handle) => {
          try {
            const response = await fetch(this.template.replace('PLACEHOLDER', encodeURIComponent(handle)));
            if (!response.ok) return { handle, markup: null };
            return { handle, markup: await response.text() };
          } catch (error) {
            return { handle, markup: null };
          }
        })
      );

      // A product that no longer exists is dropped rather than retried forever.
      const missing = results.filter((r) => r.markup === null).map((r) => r.handle);
      if (missing.length > 0) {
        const kept = handles.filter((h) => !missing.includes(h));
        localStorage.setItem('wishlist', JSON.stringify(kept));
      }

      const cards = results.filter((r) => r.markup);

      if (cards.length === 0) {
        this.updateCount(0);
        this.show(this.empty);
        return;
      }

      this.grid.innerHTML = cards
        .map((card) => `<li>${card.markup}</li>`)
        .join('');

      this.updateCount(cards.length);
      this.show(this.grid);
      if (this.clear) this.clear.hidden = false;
    }

    /**
     * Only the number is written from script; the noun beside it stays in the
     * markup where Liquid translated it. Building the whole sentence in
     * JavaScript would mean shipping a second copy of the wording that no
     * translator ever sees.
     */
    updateCount(total) {
      const label = document.querySelector('[data-wishlist-count-label]');
      if (!label) return;

      const value = label.querySelector('[data-wishlist-count-value]');
      if (value) value.textContent = String(total);
      label.hidden = total === 0;
    }

    show(target) {
      if (this.loading) this.loading.hidden = true;
      if (this.grid) this.grid.hidden = target !== this.grid;
      if (this.empty) this.empty.hidden = target !== this.empty;
      if (this.clear) this.clear.hidden = target !== this.grid;
    }
  }

  if (!customElements.get('wishlist-page')) {
    customElements.define('wishlist-page', WishlistPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  /**
   * WAI-ARIA tabs: arrow keys, Home and End move between tabs; each tab
   * activates on focus. The underline slides under the active tab.
   */
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;

      this.list = this.querySelector('[data-tablist]');
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.indicator = this.querySelector('[data-indicator]');
      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), { signal });
        tab.addEventListener('keydown', (event) => this.onKey(event, index), { signal });
      });

      // Find-in-page opened a closed panel: make its tab the active one.
      this.panels.forEach((panel, index) => {
        panel.addEventListener('beforematch', () => this.select(index, { focus: false }), { signal });
      });

      this.resizeObserver = new ResizeObserver(() => {
        this.list.classList.toggle('is-overflowing', this.list.scrollWidth > this.list.clientWidth + 1);
        this.moveIndicator();
      });
      this.resizeObserver.observe(this.list);

      window.addEventListener('hashchange', () => this.openFromHash(true), { signal });
      this.openFromHash(false);

      requestAnimationFrame(() => {
        this.moveIndicator();
        this.classList.add('is-ready');
      });
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    select(index, { focus = false } = {}) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel, i) => {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', 'until-found');
        }
      });

      const tab = this.tabs[index];
      if (focus) tab.focus();
      this.revealTab(tab);
      this.moveIndicator();
    }

    onKey(event, index) {
      const last = this.tabs.length - 1;
      const keys = { ArrowRight: index === last ? 0 : index + 1, ArrowLeft: index === 0 ? last : index - 1, Home: 0, End: last };
      if (!(event.key in keys)) return;
      event.preventDefault();
      this.select(keys[event.key], { focus: true });
    }

    /** Scrolls only the tab strip, never the page. */
    revealTab(tab) {
      const list = this.list.getBoundingClientRect();
      const box = tab.getBoundingClientRect();
      if (box.left < list.left) this.list.scrollBy({ left: box.left - list.left - 24, behavior: 'smooth' });
      else if (box.right > list.right) this.list.scrollBy({ left: box.right - list.right + 32, behavior: 'smooth' });
    }

    moveIndicator() {
      const active = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      if (!active || !this.indicator) return;
      this.list.style.setProperty('--ind-x', `${active.offsetLeft}px`);
      this.list.style.setProperty('--ind-w', active.offsetWidth);
    }

    openFromHash(scroll) {
      const slug = decodeURIComponent(window.location.hash.slice(1));
      if (!slug) return;
      const index = this.tabs.findIndex((tab) => tab.dataset.slug === slug);
      if (index === -1) return;
      this.select(index);
      if (scroll) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else requestAnimationFrame(() => this.scrollIntoView({ block: 'start' }));
    }
  }

  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', ProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /**
   * Product page behaviour: gallery swapping, variant selection, quantity
   * stepper, zoom dialog and the sticky buy bar.
   *
   * All of it is enhancement. Without JavaScript the radio inputs still post
   * the correct variant, the number input still works, and the gallery shows
   * the first image.
   */
  /* ---------- size family: in-place swap between sibling products ---------- */

  const siblingCache = new Map();

  function fetchSiblingHtml(url) {
    if (siblingCache.has(url)) return siblingCache.get(url);
    const request = fetch(url, { headers: { Accept: 'text/html' } }).then((response) => {
      if (!response.ok) throw new Error(`Size swap failed: ${response.status}`);
      return response.text();
    });
    request.catch(() => siblingCache.delete(url));
    siblingCache.set(url, request);
    return request;
  }

  /**
   * Swaps the page's sections for those of a sibling product, so picking a
   * size feels like picking a variant: no reload, no scroll jump, no flash.
   * Only when both pages use the same product template (same section ids);
   * anything unexpected falls back to a normal navigation.
   */
  async function swapToProduct(url, { push = true } = {}) {
    const main = document.getElementById('main-content');
    const page = main && main.querySelector('product-page');
    if (!main || !page) {
      window.location.assign(url);
      return;
    }

    page.setAttribute('aria-busy', 'true');
    try {
      const html = await fetchSiblingHtml(url);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incoming = Array.from(doc.querySelectorAll('#main-content > .shopify-section'));
      const current = Array.from(main.querySelectorAll(':scope > .shopify-section'));
      const sameTemplate =
        incoming.length > 0 && incoming.map((el) => el.id).join() === current.map((el) => el.id).join();

      if (!sameTemplate) {
        window.location.assign(url);
        return;
      }

      incoming.forEach((section) => {
        document.getElementById(section.id).replaceWith(document.adoptNode(section));
      });

      document.title = doc.title;
      const canonical = doc.querySelector('link[rel="canonical"]');
      const ownCanonical = document.querySelector('link[rel="canonical"]');
      if (canonical && ownCanonical) ownCanonical.href = canonical.href;
      if (push) window.history.pushState({ productSwap: true }, '', url);

      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
        window.Shopify.PaymentButton.init();
      }
      if (typeof window.syncWishlistButtons === 'function') window.syncWishlistButtons();

      // Keep keyboard users where they were: on the size they just chose.
      const chosen = main.querySelector('[data-sibling-link][aria-current]');
      if (chosen) chosen.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('product:swapped', { detail: { url } }));
    } catch (error) {
      window.location.assign(url);
    }
  }

  // Back/forward between sizes. Hash-only changes (tab links) are ignored.
  window.addEventListener('popstate', () => {
    const page = document.querySelector('#main-content product-page');
    if (!page || !page.querySelector('[data-sibling-link]')) return;
    const shown = new URL(page.dataset.productUrl || '', window.location.origin).pathname;
    if (shown !== window.location.pathname) swapToProduct(window.location.href, { push: false });
  });

  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.signal = this.controller.signal;

      // The same markup is reused inside the quick view. There it must not
      // rewrite the host page's URL or float a sticky bar over the modal.
      this.isQuickView = Boolean(this.closest('quick-view-modal'));

      const data = this.querySelector('[data-variant-data]');
      try {
        this.variants = data ? JSON.parse(data.textContent) : [];
      } catch (error) {
        this.variants = [];
      }

      this.setupGallery();
      this.setupOptions();
      this.setupQuantity();
      this.setupZoom();
      this.setupBuyBar();
      this.setupShare();
      this.setupOfferCodes();
      this.setupSiblings();
    }

    setupSiblings() {
      const { signal } = this;
      this.querySelectorAll('[data-sibling-link]').forEach((link) => {
        link.addEventListener(
          'click',
          (event) => {
            // New-tab and modified clicks keep their normal meaning.
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            if (link.hasAttribute('aria-current')) return;

            // Inside the quick view the modal re-renders with the other size.
            const modal = this.closest('quick-view-modal');
            if (modal && typeof modal.open === 'function') {
              modal.open(link.href, link);
              return;
            }
            swapToProduct(link.href);
          },
          { signal }
        );

        // Warm the other size while the pointer is on its way.
        const warm = () => {
          if (!link.hasAttribute('aria-current')) fetchSiblingHtml(link.href).catch(() => {});
        };
        link.addEventListener('pointerenter', warm, { signal, passive: true });
        link.addEventListener('focus', warm, { signal });
      });
    }

    /** Canonical product URL for the selected variant, wherever this renders. */
    get productUrl() {
      const url = new URL(this.dataset.productUrl || window.location.href, window.location.origin);
      const idInput = this.querySelector('[data-variant-id]');
      if (idInput && this.variants.length > 1) url.searchParams.set('variant', idInput.value);
      return url.toString();
    }

    /* ---------- offer codes ---------- */

    setupOfferCodes() {
      this.querySelectorAll('[data-copy-code]').forEach((button) => {
        button.addEventListener(
          'click',
          async () => {
            const code = button.dataset.copyCode;
            const status = button.parentElement.querySelector('[data-copy-status]');
            const hint = button.querySelector('[data-copy-hint]');

            try {
              await navigator.clipboard.writeText(code);
            } catch (error) {
              // No clipboard permission: select the code so a manual copy is
              // one keystroke away, and say nothing was copied.
              const range = document.createRange();
              range.selectNodeContents(button.querySelector('code'));
              const selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
              return;
            }

            const original = hint ? hint.textContent : '';
            button.classList.add('is-copied');
            if (hint) hint.textContent = button.dataset.copiedText;
            if (status) status.textContent = button.dataset.copiedText;

            clearTimeout(button._copyTimer);
            button._copyTimer = setTimeout(() => {
              button.classList.remove('is-copied');
              if (hint) hint.textContent = original;
              if (status) status.textContent = '';
            }, 2000);
          },
          { signal: this.signal }
        );
      });
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.observer) this.observer.disconnect();
      if (this.footerObserver) this.footerObserver.disconnect();
      // A quick view never owned the flag; clearing it would hide the host
      // product page's own bar state.
      if (!this.isQuickView) document.documentElement.classList.remove('buybar-up');
    }

    /* ---------- gallery ---------- */

    setupGallery() {
      this.mediaItems = Array.from(this.querySelectorAll('[data-media]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.showMedia(thumb.dataset.mediaId), { signal: this.signal });
      });

      const prev = this.querySelector('[data-media-prev]');
      const next = this.querySelector('[data-media-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1), { signal: this.signal });
      if (next) next.addEventListener('click', () => this.step(1), { signal: this.signal });

      this.setupSwipe();
    }

    /**
     * Swipe between images.
     *
     * On a phone the arrows are the only way through the gallery, and they are
     * the one interaction nobody reaches for on a touchscreen — the gesture is
     * what a shopper actually tries first.
     *
     * Pointer events rather than touch events so it works with a stylus and a
     * trackpad drag, and only for `touch`: a mouse drag on an image means
     * "drag the image", not "next".
     *
     * The listeners are passive. Nothing here calls preventDefault, because
     * doing so would kill vertical scrolling started on top of the gallery —
     * which is most of the page on a phone. Instead the horizontal move is
     * only treated as a swipe when it clearly beats the vertical one.
     */
    setupSwipe() {
      const stage = this.querySelector('[data-media]')?.parentElement;
      if (!stage || this.mediaItems.length < 2) return;

      let startX = 0;
      let startY = 0;
      let tracking = false;

      stage.addEventListener(
        'pointerdown',
        (event) => {
          if (event.pointerType !== 'touch') return;
          tracking = true;
          startX = event.clientX;
          startY = event.clientY;
        },
        { passive: true, signal: this.signal }
      );

      stage.addEventListener(
        'pointerup',
        (event) => {
          if (!tracking) return;
          tracking = false;

          const dx = event.clientX - startX;
          const dy = event.clientY - startY;

          // 40px of travel, and clearly more sideways than vertical, or a
          // slightly diagonal scroll would flick the gallery on every swipe
          // down the page.
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          this.step(dx < 0 ? 1 : -1);

          // The lift after a swipe can still produce a click; it must not
          // also open the zoom viewer.
          this.suppressClick = true;
          setTimeout(() => (this.suppressClick = false), 350);
        },
        { passive: true, signal: this.signal }
      );

      stage.addEventListener(
        'pointercancel',
        () => {
          tracking = false;
        },
        { passive: true, signal: this.signal }
      );
    }

    /* Wraps at both ends, so the arrows never dead-end on a short gallery. */
    step(direction) {
      if (this.mediaItems.length < 2) return;

      const current = this.mediaItems.findIndex((item) => item.classList.contains('is-active'));
      const from = current === -1 ? 0 : current;
      const total = this.mediaItems.length;
      const target = (from + direction + total) % total;

      this.showMedia(this.mediaItems[target].dataset.mediaId);
    }

    showMedia(mediaId) {
      if (!mediaId || mediaId === '0') return;

      const position = this.mediaItems.findIndex((item) => item.dataset.mediaId === mediaId);
      const indexEl = this.querySelector('[data-media-index]');
      if (indexEl && position > -1) indexEl.textContent = position + 1;

      this.mediaItems.forEach((item) => {
        const active = item.dataset.mediaId === mediaId;
        item.classList.toggle('is-active', active);

        // Stop any video that just moved out of view.
        if (!active) {
          const video = item.querySelector('video');
          if (video) video.pause();
        }
      });

      this.thumbs.forEach((thumb) => {
        const active = thumb.dataset.mediaId === mediaId;
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
          this.revealThumb(thumb);
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    /**
     * Keeps the active thumbnail visible in its strip after a swipe or arrow
     * press. Scrolls only the strip: scrollIntoView would also drag the page.
     */
    revealThumb(thumb) {
      const strip = thumb.closest('.gallery__thumbs');
      if (!strip) return;

      const s = strip.getBoundingClientRect();
      const t = thumb.getBoundingClientRect();
      const pad = 8;
      let left = 0;
      let top = 0;

      if (t.left < s.left) left = t.left - s.left - pad;
      else if (t.right > s.right) left = t.right - s.right + pad;
      if (t.top < s.top) top = t.top - s.top - pad;
      else if (t.bottom > s.bottom) top = t.bottom - s.bottom + pad;

      if (left || top) strip.scrollBy({ left, top, behavior: 'smooth' });
    }

    /* ---------- variants ---------- */

    setupOptions() {
      this.optionInputs = Array.from(this.querySelectorAll('[data-option-input]'));
      if (this.optionInputs.length === 0) return;

      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange(), { signal: this.signal });
      });

      this.markUnavailable();
    }

    /**
     * One slot per product option, by position. Single-value options have no
     * picker, so their slot stays null (matches anything) instead of the
     * remaining choices shifting one place to the left.
     */
    get selectedOptions() {
      const count = this.variants[0] ? this.variants[0].options.length : 0;
      const selected = new Array(count).fill(null);
      this.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        const index = Number(fieldset.dataset.optionIndex) - 1;
        if (checked && index >= 0) selected[index] = checked.value;
      });
      return selected;
    }

    findVariant(options) {
      return this.variants.find((variant) =>
        variant.options.every((value, i) => options[i] == null || value === options[i])
      );
    }

    onOptionChange() {
      const selected = this.selectedOptions;

      this.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        const display = fieldset.querySelector('[data-option-display]');
        if (display) display.textContent = selected[Number(fieldset.dataset.optionIndex) - 1] || '';
      });

      this.markUnavailable();

      const variant = this.findVariant(selected);
      const add = this.querySelector('[data-add]');
      const barAdd = this.querySelector('[data-buybar-add]');

      if (!variant) {
        if (add) add.disabled = true;
        if (barAdd) barAdd.disabled = true;
        return;
      }

      const idInput = this.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;
      this.fillShareLinks();

      const price = this.querySelector('[data-price]');
      if (price) price.textContent = variant.price;

      const barPrice = this.querySelector('[data-buybar-price]');
      if (barPrice) barPrice.textContent = variant.price;

      const codPrice = this.querySelector('[data-cod-price]');
      if (codPrice) codPrice.textContent = variant.price;

      const prepaidPrice = this.querySelector('[data-prepaid-price]');
      if (prepaidPrice) prepaidPrice.textContent = variant.prepaidPrice;

      const prepaidSaving = this.querySelector('[data-prepaid-saving]');
      if (prepaidSaving) prepaidSaving.textContent = variant.prepaidSaving;

      const compare = this.querySelector('[data-compare]');
      const compareValue = this.querySelector('[data-compare-value]');
      const save = this.querySelector('[data-save]');
      const block = this.querySelector('[data-price-block]');

      if (compare) compare.hidden = !variant.onSale;
      if (compareValue) compareValue.textContent = variant.compareAt;
      if (save) save.hidden = !variant.onSale;
      if (block) block.classList.toggle('pdp__price--sale', variant.onSale);

      // The percent was already formatted and translated in Liquid for the
      // gallery badge, so the pill reuses it rather than recomputing.
      const saveValue = this.querySelector('[data-save-value]');
      if (saveValue && variant.badgeKind === 'sale') saveValue.textContent = variant.badge;

      if (add) add.disabled = !variant.available;
      if (barAdd) barAdd.disabled = !variant.available;

      const text = variant.available ? this.dataset.addText : this.dataset.soldOutText;

      const label = this.querySelector('[data-add-label]');
      if (label) label.textContent = text;

      // The pill mirrors the main button rather than keeping its own wording —
      // it used to read "Add to cart" on a sold-out variant.
      const barLabel = this.querySelector('[data-buybar-label]');
      if (barLabel) barLabel.textContent = text;

      const barVariant = this.querySelector('[data-buybar-variant]');
      if (barVariant) barVariant.textContent = variant.options.join(' / ');

      // Express checkout is meaningless for a variant that can't be bought.
      const dynamic = this.querySelector('[data-dynamic]');
      if (dynamic) dynamic.hidden = !variant.available;

      const stock = this.querySelector('[data-stock]');
      const stockText = this.querySelector('[data-stock-text]');
      if (stock && stockText) {
        stock.className = `pdp__stock pdp__stock--${variant.stockLevel}`;
        stockText.textContent = variant.stockText;
      }

      const badge = this.querySelector('[data-stage-badge]');
      if (badge) {
        badge.className = `gallery__badge gallery__badge--${variant.badgeKind}`;
        badge.textContent = variant.badge;
        badge.hidden = !variant.badge;
      }

      const skuRow = this.querySelector('[data-sku-row]');
      const sku = this.querySelector('[data-sku]');
      if (skuRow && sku) {
        sku.textContent = variant.sku;
        skuRow.hidden = !variant.sku;
      }

      this.showMedia(String(variant.mediaId));

      // Keeps the URL shareable without adding a history entry per click. Not
      // in the quick view: that would stamp ?variant= onto the collection page.
      if (this.isQuickView) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    /**
     * Flags each option value that has no available variant once combined with
     * the other current selections, so shoppers see the full range but know
     * what they can actually buy.
     */
    markUnavailable() {
      const selected = this.selectedOptions;

      this.optionInputs.forEach((input) => {
        const fieldset = input.closest('[data-option-index]');
        const index = Number(fieldset.dataset.optionIndex) - 1;
        const probe = selected.slice();
        probe[index] = input.value;

        const match = this.variants.find(
          (variant) =>
            variant.available &&
            variant.options.every((value, i) => probe[i] == null || value === probe[i])
        );

        input.classList.toggle('is-unavailable', !match);
      });
    }

    /* ---------- quantity ---------- */

    setupQuantity() {
      const input = this.querySelector('[data-qty]');
      if (!input) return;

      const step = (delta) => {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const down = this.querySelector('[data-qty-down]');
      const up = this.querySelector('[data-qty-up]');
      if (down) down.addEventListener('click', () => step(-1), { signal: this.signal });
      if (up) up.addEventListener('click', () => step(1), { signal: this.signal });
    }

    /* ---------- zoom ---------- */

    /**
     * Full-screen viewer over the image media only (videos and 3D models are
     * skipped). One image at a time, loaded at 2400px on open. Magnify is a
     * CSS scale around a movable transform-origin: a mouse pans by hovering,
     * a finger pans by dragging. Leaving the viewer syncs the gallery to the
     * image the shopper ended on.
     */
    setupZoom() {
      const dialog = this.querySelector('[data-zoom]');
      if (!dialog) return;

      this.zoom = {
        dialog,
        image: dialog.querySelector('[data-zoom-image]'),
        viewport: dialog.querySelector('[data-zoom-viewport]'),
        count: dialog.querySelector('[data-zoom-count]'),
        toggle: dialog.querySelector('[data-zoom-toggle]'),
        toggleLabel: dialog.querySelector('[data-zoom-toggle-label]'),
        items: this.mediaItems.filter((item) => item.dataset.zoomSrc),
        index: 0,
        scale: 1,
        originX: 50,
        originY: 50,
      };
      if (this.zoom.items.length === 0) return;

      const { signal } = this;
      const open = this.querySelector('[data-zoom-open]');
      if (open) open.addEventListener('click', () => this.openZoom(), { signal });

      // The photo itself is the biggest zoom target on the page.
      this.zoom.items.forEach((item) => {
        item.addEventListener(
          'click',
          () => {
            if (this.suppressClick) return;
            this.openZoom();
          },
          { signal }
        );
      });

      dialog.querySelector('[data-zoom-close]')?.addEventListener('click', () => this.closeZoom(), { signal });
      dialog.querySelector('[data-zoom-prev]')?.addEventListener('click', () => this.stepZoom(-1), { signal });
      dialog.querySelector('[data-zoom-next]')?.addEventListener('click', () => this.stepZoom(1), { signal });
      this.zoom.toggle?.addEventListener('click', () => this.setZoomScale(this.zoom.scale > 1 ? 1 : 2.5), { signal });

      dialog.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'ArrowLeft') this.stepZoom(-1);
          if (event.key === 'ArrowRight') this.stepZoom(1);
        },
        { signal }
      );

      // Escape goes through closeZoom so the gallery is synced either way.
      dialog.addEventListener('close', () => this.onZoomClosed(), { signal });

      this.zoom.image.addEventListener('load', () => dialog.classList.remove('is-loading'), { signal });
      this.zoom.image.addEventListener('error', () => dialog.classList.remove('is-loading'), { signal });

      this.setupZoomGestures();
    }

    openZoom() {
      const { dialog, items } = this.zoom;
      const active = items.findIndex((item) => item.classList.contains('is-active'));
      this.showZoom(active === -1 ? 0 : active);
      dialog.showModal();
      requestAnimationFrame(() => dialog.classList.add('is-open'));
    }

    closeZoom() {
      if (this.zoom.dialog.open) this.zoom.dialog.close();
    }

    onZoomClosed() {
      const { dialog, items, index } = this.zoom;
      dialog.classList.remove('is-open', 'is-zoomed');
      this.setZoomScale(1);
      const item = items[index];
      if (item) this.showMedia(item.dataset.mediaId);
    }

    stepZoom(direction) {
      const total = this.zoom.items.length;
      if (total < 2) return;
      this.showZoom((this.zoom.index + direction + total) % total);
    }

    showZoom(index) {
      const { dialog, image, count, items } = this.zoom;
      const item = items[index];
      this.zoom.index = index;
      this.setZoomScale(1);

      if (image.getAttribute('src') !== item.dataset.zoomSrc) {
        dialog.classList.add('is-loading');
        image.src = item.dataset.zoomSrc;
      }
      image.alt = item.dataset.zoomAlt || '';
      if (count) count.textContent = items.length > 1 ? `${index + 1} / ${items.length}` : '';

      // Neighbours load in the background so the arrows feel instant.
      [index - 1, index + 1].forEach((i) => {
        const neighbour = items[(i + items.length) % items.length];
        if (neighbour && neighbour !== item) new Image().src = neighbour.dataset.zoomSrc;
      });
    }

    setZoomScale(scale, originX = 50, originY = 50) {
      const zoom = this.zoom;
      zoom.scale = scale;
      zoom.originX = originX;
      zoom.originY = originY;
      zoom.image.style.transformOrigin = `${originX}% ${originY}%`;
      zoom.image.style.transform = scale > 1 ? `scale(${scale})` : '';
      zoom.dialog.classList.toggle('is-zoomed', scale > 1);

      if (zoom.toggle) {
        zoom.toggle.setAttribute('aria-pressed', String(scale > 1));
        const label = scale > 1 ? zoom.toggle.dataset.labelOut : zoom.toggle.dataset.labelIn;
        if (zoom.toggleLabel && label) zoom.toggleLabel.textContent = label;
      }
    }

    /** Percentage position of a pointer over the rendered image, clamped. */
    zoomPoint(event) {
      const rect = this.zoom.image.getBoundingClientRect();
      const unscaledLeft = rect.left + (rect.width - rect.width / this.zoom.scale) * (this.zoom.originX / 100);
      const unscaledTop = rect.top + (rect.height - rect.height / this.zoom.scale) * (this.zoom.originY / 100);
      const width = rect.width / this.zoom.scale;
      const height = rect.height / this.zoom.scale;
      const clamp = (v) => Math.min(100, Math.max(0, v));
      return {
        x: clamp(((event.clientX - unscaledLeft) / width) * 100),
        y: clamp(((event.clientY - unscaledTop) / height) * 100),
        width,
        height,
      };
    }

    setupZoomGestures() {
      const { viewport, image, dialog } = this.zoom;
      const { signal } = this;
      let start = null;
      let moved = false;

      viewport.addEventListener(
        'pointerdown',
        (event) => {
          start = { x: event.clientX, y: event.clientY, ox: this.zoom.originX, oy: this.zoom.originY, type: event.pointerType };
          moved = false;
          if (event.pointerType !== 'mouse') {
            try {
              viewport.setPointerCapture(event.pointerId);
            } catch (error) {
              // The pointer was already released; the gesture still works.
            }
          }
        },
        { signal }
      );

      viewport.addEventListener(
        'pointermove',
        (event) => {
          // Mouse: the image follows the cursor while magnified.
          if (event.pointerType === 'mouse') {
            if (this.zoom.scale > 1) {
              const point = this.zoomPoint(event);
              this.setZoomScale(this.zoom.scale, point.x, point.y);
            }
            return;
          }
          if (!start) return;

          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;

          if (this.zoom.scale > 1) {
            // Drag pans: moving the origin by d / (scale - 1) keeps the point
            // under the finger fixed.
            const rect = image.getBoundingClientRect();
            const width = rect.width / this.zoom.scale;
            const height = rect.height / this.zoom.scale;
            const factor = 100 / (this.zoom.scale - 1);
            const clamp = (v) => Math.min(100, Math.max(0, v));
            dialog.classList.add('is-panning');
            this.setZoomScale(
              this.zoom.scale,
              clamp(start.ox - (dx / width) * factor),
              clamp(start.oy - (dy / height) * factor)
            );
          } else {
            // Unmagnified: the image follows the finger, as a hint of what
            // letting go will do.
            dialog.classList.add('is-panning');
            image.style.transform = Math.abs(dx) > Math.abs(dy) ? `translateX(${dx}px)` : `translateY(${Math.max(0, dy)}px)`;
          }
        },
        { signal }
      );

      const end = (event) => {
        if (!start) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        const wasTouch = start.type !== 'mouse';
        start = null;
        dialog.classList.remove('is-panning');

        if (wasTouch && this.zoom.scale === 1 && moved) {
          image.style.transform = '';
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) this.stepZoom(dx < 0 ? 1 : -1);
          else if (dy > 90 && dy > Math.abs(dx)) this.closeZoom();
          return;
        }

        // A tap or click (not a drag) toggles magnification at that point.
        if (!moved && event.type === 'pointerup' && event.target === image) {
          if (this.zoom.scale > 1) {
            this.setZoomScale(1);
          } else {
            const point = this.zoomPoint(event);
            this.setZoomScale(2.5, point.x, point.y);
          }
        }
      };

      viewport.addEventListener('pointerup', end, { signal });
      viewport.addEventListener('pointercancel', end, { signal });
    }

    /* ---------- share ---------- */

    setupShare() {
      const button = this.querySelector('[data-share]');
      if (!button) return;

      this.shareButton = button;
      this.shareMenu = this.querySelector('[data-share-menu]');
      const supportsPopover = Boolean(this.shareMenu && typeof this.shareMenu.showPopover === 'function');
      if (!supportsPopover) this.shareMenu = null;

      const { signal } = this;
      button.addEventListener('click', () => this.onShare(), { signal });

      if (!this.shareMenu) return;

      this.shareMenu.addEventListener(
        'toggle',
        (event) => {
          const open = event.newState === 'open';
          button.setAttribute('aria-expanded', String(open));
          if (open) {
            this.fillShareLinks();
            this.positionShareMenu();
            this.shareMenu.querySelector('.share-menu__item')?.focus();
          }
        },
        { signal }
      );

      // Keep it attached to the button while the page or panel scrolls.
      const reposition = () => this.shareMenu.matches(':popover-open') && this.positionShareMenu();
      window.addEventListener('scroll', reposition, { passive: true, capture: true, signal });
      window.addEventListener('resize', reposition, { passive: true, signal });

      this.shareMenu.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('[data-share-copy]')) {
            event.preventDefault();
            this.copyShareLink();
            return;
          }
          if (event.target.closest('[data-share-network]')) this.shareMenu.hidePopover();
        },
        { signal }
      );

      // Escape returns focus to the button; light-dismiss clicks elsewhere don't.
      this.shareMenu.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          this.shareMenu.hidePopover();
          button.focus();
        },
        { signal }
      );
    }

    async onShare() {
      const url = this.productUrl;
      const title = this.shareButton.dataset.shareTitle || document.title;
      const touch = window.matchMedia('(pointer: coarse)').matches;

      // The native sheet on phones, where it lists the shopper's own apps.
      if (touch && navigator.share) {
        try {
          await navigator.share({ title, url });
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          // Any other failure: fall through to the menu rather than nothing.
        }
      }

      if (this.shareMenu) {
        this.shareMenu.togglePopover();
        return;
      }

      // Very old browsers: no popover support, so just copy.
      this.copyShareLink();
    }

    /**
     * Points every share link in this product (the header menu and the
     * "Share this item" row) at the current product URL, variant included.
     */
    fillShareLinks() {
      const links = this.querySelectorAll('[data-share-network]');
      if (links.length === 0) return;

      const url = this.productUrl;
      const titleEl = this.querySelector('[data-product-title]');
      const title = this.shareButton?.dataset.shareTitle || (titleEl ? titleEl.textContent.trim() : document.title);
      const e = encodeURIComponent;

      links.forEach((link) => {
        const network = link.dataset.shareNetwork;
        let image = this.shareButton?.dataset.shareImage || '';
        if (!image && network === 'pinterest' && link.getAttribute('href')) {
          try {
            image = new URL(link.href).searchParams.get('media') || '';
          } catch (error) {
            image = '';
          }
        }

        const hrefs = {
          whatsapp: `https://wa.me/?text=${e(`${title} ${url}`)}`,
          facebook: `https://www.facebook.com/sharer/sharer.php?u=${e(url)}`,
          x: `https://twitter.com/intent/tweet?url=${e(url)}&text=${e(title)}`,
          pinterest: `https://pinterest.com/pin/create/button/?url=${e(url)}&description=${e(title)}${image ? `&media=${e(image)}` : ''}`,
          tumblr: `https://www.tumblr.com/widgets/share/tool?canonicalUrl=${e(url)}&title=${e(title)}`,
          telegram: `https://t.me/share/url?url=${e(url)}&text=${e(title)}`,
          email: `mailto:?subject=${e(title)}&body=${e(`${title} ${url}`)}`,
        };
        if (hrefs[network]) link.href = hrefs[network];
      });
    }

    /** Below the button, right-aligned, flipped above if there is no room. */
    positionShareMenu() {
      const menu = this.shareMenu;
      const rect = this.shareButton.getBoundingClientRect();
      const gap = 8;
      const margin = 12;
      const width = menu.offsetWidth;
      const height = menu.offsetHeight;

      let left = rect.right - width;
      left = Math.max(margin, Math.min(left, window.innerWidth - width - margin));

      let top = rect.bottom + gap;
      if (top + height > window.innerHeight - margin && rect.top - gap - height > margin) {
        top = rect.top - gap - height;
      }

      menu.style.left = `${Math.round(left)}px`;
      menu.style.top = `${Math.round(top)}px`;
    }

    async copyShareLink() {
      const url = this.productUrl;
      let copied = false;

      try {
        await navigator.clipboard.writeText(url);
        copied = true;
      } catch (error) {
        // Clipboard API refused (older Safari, insecure context): the
        // selection-based copy still works from a user gesture.
        const field = document.createElement('textarea');
        field.value = url;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
        (this.shareMenu || this).appendChild(field);
        field.select();
        try {
          copied = document.execCommand('copy');
        } catch (fallbackError) {
          copied = false;
        }
        field.remove();
      }

      if (!copied) {
        // Last resort: show the URL so it can be copied by hand.
        window.prompt(this.shareButton.dataset.shareTitle || '', url);
        return;
      }

      const copyLabel = this.shareMenu?.querySelector('[data-share-copy-label]');
      const copyItem = this.shareMenu?.querySelector('[data-share-copy]');
      const label = this.shareButton.querySelector('[data-share-label]');
      const copiedText = this.shareButton.dataset.copiedText;

      if (copyLabel) {
        const original = copyLabel.textContent;
        copyLabel.textContent = copiedText;
        copyItem.classList.add('is-copied');
        setTimeout(() => {
          copyLabel.textContent = original;
          copyItem.classList.remove('is-copied');
          if (this.shareMenu.matches(':popover-open')) this.shareMenu.hidePopover();
        }, 1400);
        return;
      }

      // No menu: the bubble on the button itself.
      const original = label ? label.textContent : '';
      this.shareButton.classList.add('is-copied');
      if (label) label.textContent = copiedText;
      setTimeout(() => {
        this.shareButton.classList.remove('is-copied');
        if (label) label.textContent = original;
      }, 2000);
    }

    /* ---------- sticky buy bar ---------- */

    /**
     * Three independent conditions decide whether the pill is on screen, and
     * all three have to agree. Keeping them as separate flags means each one
     * can be reasoned about — and changed — without unpicking the others.
     *
     *   past    the main add-to-cart has scrolled out of sight, so the pill
     *           has a job to do at all
     *   peek    the shopper is not actively scrolling down; a control that
     *           follows you down the page is in the way, one that returns the
     *           moment you look back up is not
     *   footer  the footer is not on screen — covering the legal links with a
     *           sales control is both rude and, for policy links, risky
     */
    setupBuyBar() {
      const bar = this.querySelector('[data-buybar]');
      const sentinel = this.querySelector('[data-sticky-sentinel]');
      if (!bar || !sentinel) return;

      // Inside the quick view the buttons are always on screen, and a fixed
      // bar inside a transformed sheet would anchor to the sheet, not the page.
      if (this.isQuickView) {
        bar.remove();
        return;
      }

      this.bar = bar;
      this.barPast = false;
      this.barPeek = true;
      this.barAtFooter = false;
      this.barShown = false;

      // Accumulated downward travel since the pill was last revealed. Using a
      // running total rather than a single frame's delta stops a trackpad's
      // one-pixel jitter from flickering the bar on and off.
      this.barDown = 0;
      this.barLastY = window.scrollY;
      this.barTicking = false;

      this.observer = new IntersectionObserver(
        ([entry]) => {
          // Only once the sentinel has scrolled off the TOP — otherwise the
          // pill would appear before the shopper has even reached the button.
          const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;

          // Arriving at the threshold counts as a fresh reveal, so clear the
          // downward budget: the pill should show the instant it becomes
          // relevant, even though the shopper got here scrolling down.
          if (past && !this.barPast) {
            this.barDown = 0;
            this.barPeek = true;
          }

          this.barPast = past;
          this.syncBuyBar();
        },
        { threshold: 0 }
      );
      this.observer.observe(sentinel);

      /**
       * Stand down at the footer. The margin holds the pill back until the
       * footer has risen far enough to actually sit underneath it, rather than
       * the moment its top edge grazes the viewport.
       */
      const footer = document.querySelector('.ft');
      if (footer) {
        this.footerObserver = new IntersectionObserver(
          ([entry]) => {
            this.barAtFooter = entry.isIntersecting;
            this.syncBuyBar();
          },
          { threshold: 0, rootMargin: '0px 0px -110px 0px' }
        );
        this.footerObserver.observe(footer);
      }

      window.addEventListener('scroll', () => this.onBuyBarScroll(), {
        passive: true,
        signal: this.signal,
      });
    }

    onBuyBarScroll() {
      if (this.barTicking) return;
      this.barTicking = true;

      requestAnimationFrame(() => {
        this.barTicking = false;

        const y = Math.max(window.scrollY, 0);
        const delta = y - this.barLastY;

        // Below this the movement is noise, not intent.
        if (Math.abs(delta) < 6) return;
        this.barLastY = y;

        if (delta > 0) {
          this.barDown += delta;
          if (this.barDown > 140) this.barPeek = false;
        } else {
          this.barDown = 0;
          this.barPeek = true;
        }

        this.syncBuyBar();
      });
    }

    syncBuyBar() {
      const show = this.barPast && this.barPeek && !this.barAtFooter;
      if (show === this.barShown) return;

      this.barShown = show;
      this.bar.classList.toggle('is-visible', show);

      // Published on <html> so the back-to-top button — which owns the same
      // corner but knows nothing about products — can step over the pill only
      // while it is actually there.
      document.documentElement.classList.toggle('buybar-up', show);
    }
  }

  if (!customElements.get('product-page')) {
    customElements.define('product-page', ProductPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  /**
   * Fetches the recommendations section markup when it nears the viewport and
   * swaps in the rendered grid.
   */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.load(url);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async load(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) return;

        const markup = await response.text();
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const fresh = parsed.querySelector('product-recommendations');

        // No recommendations for this product is a normal outcome, not an error.
        if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
      } catch (error) {
        // A failed request just leaves the section empty.
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
  /**
   * Track-order lookup. Validates, then hands off to the courier or to
   * sign-in. Nothing is sent anywhere but the destination the shopper is
   * shown; there is no API call and no key in the browser.
   */
  class TrackOrderForm extends HTMLElement {
    static PATTERNS = {
      awb: /^[A-Z0-9-]{6,40}$/,
      order: /^[A-Z0-9-]{1,20}$/,
      email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
      phone: /^\+?\d{10,13}$/,
    };

    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;

      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.status = this.querySelector('[data-status]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab, true), { signal });
        tab.addEventListener('keydown', (event) => this.onTabKey(event), { signal });
      });
      this.syncTabIndex();

      this.panels.forEach((form) => {
        form.addEventListener('submit', (event) => this.onSubmit(event, form), { signal });
        form.addEventListener('input', (event) => this.clearError(event.target), { signal });
      });

      this.prefillFromUrl();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }

    /* ---------- tabs ---------- */

    select(mode, focusInput) {
      this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.tab === mode)));
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.panel !== mode;
      });
      this.syncTabIndex();
      this.setStatus('');

      if (focusInput) {
        const input = this.querySelector(`[data-panel="${mode}"] input`);
        if (input) input.focus();
      }
    }

    syncTabIndex() {
      this.tabs.forEach((tab) => {
        tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
      });
    }

    /** Arrow keys move between tabs, per the WAI-ARIA tabs pattern. */
    onTabKey(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();

      const index = this.tabs.indexOf(event.currentTarget);
      const last = this.tabs.length - 1;
      let next = index;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;

      this.select(this.tabs[next].dataset.tab, false);
      this.tabs[next].focus();
    }

    /* ---------- submit ---------- */

    onSubmit(event, form) {
      event.preventDefault();
      const mode = form.dataset.panel;
      const url = mode === 'awb' ? this.awbDestination(form) : this.orderDestination(form);
      if (!url) return;

      const button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-busy', 'true');

      if (url.external) {
        this.setStatus(this.dataset.opening);
        // A new tab keeps the store open behind the courier page. Blocked
        // pop-ups fall back to the same tab rather than doing nothing.
        const opened = window.open(url.href, '_blank');
        if (opened) {
          opened.opener = null;
        } else {
          window.location.assign(url.href);
        }
        setTimeout(() => button && button.removeAttribute('aria-busy'), 800);
      } else {
        this.setStatus(this.dataset.redirecting);
        window.location.assign(url.href);
      }
    }

    awbDestination(form) {
      const input = form.querySelector('[data-input="awb"]');
      const awb = input.value.replace(/\s+/g, '').toUpperCase();

      if (!TrackOrderForm.PATTERNS.awb.test(awb)) {
        this.showError(input, this.dataset.errorAwb);
        return null;
      }

      return { href: this.fill(this.dataset.awbUrl, { awb }), external: true };
    }

    orderDestination(form) {
      const input = form.querySelector('[data-input="order"]');
      const order = input.value.trim().replace(/^#/, '').replace(/\s+/g, '').toUpperCase();
      let valid = true;

      if (!TrackOrderForm.PATTERNS.order.test(order)) {
        this.showError(input, this.dataset.errorOrder);
        valid = false;
      }

      const contactInput = form.querySelector('[data-input="contact"]');
      let contact = '';
      if (contactInput) {
        contact = contactInput.value.trim();
        const phone = contact.replace(/[\s()-]/g, '');
        const isEmail = TrackOrderForm.PATTERNS.email.test(contact);
        const isPhone = TrackOrderForm.PATTERNS.phone.test(phone);
        if (!isEmail && !isPhone) {
          this.showError(contactInput, this.dataset.errorContact);
          if (valid) contactInput.focus();
          valid = false;
        } else if (isPhone) {
          contact = phone;
        }
      }

      if (!valid) return null;

      if (this.dataset.orderUrl) {
        return { href: this.fill(this.dataset.orderUrl, { order, contact }), external: true };
      }

      // No order-tracking link configured: Shopify's own account pages show
      // the order and its live status after a one-time-code sign-in.
      return { href: this.dataset.loginUrl, external: false };
    }

    /** Placeholders are replaced with URL-encoded values only. */
    fill(template, values) {
      return Object.entries(values).reduce(
        (url, [key, value]) => url.split(`{${key}}`).join(encodeURIComponent(value)),
        template
      );
    }

    /* ---------- feedback ---------- */

    showError(input, message) {
      const error = this.querySelector(`[data-error-for="${input.dataset.input}"]`);
      input.setAttribute('aria-invalid', 'true');
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }
      if (!this.querySelector('[aria-invalid="true"]:focus')) input.focus();
    }

    clearError(input) {
      if (!input || input.getAttribute('aria-invalid') !== 'true') return;
      input.removeAttribute('aria-invalid');
      const error = this.querySelector(`[data-error-for="${input.dataset.input}"]`);
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
    }

    setStatus(message) {
      if (this.status) this.status.textContent = message || '';
    }

    /** Links from emails can carry ?awb= or ?order= to land ready to submit. */
    prefillFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const awb = params.get('awb');
      const order = params.get('order');

      if (awb && this.querySelector('[data-panel="awb"]')) {
        this.select('awb', false);
        this.querySelector('[data-input="awb"]').value = awb.slice(0, 40);
      } else if (order && this.querySelector('[data-panel="order"]')) {
        this.select('order', false);
        this.querySelector('[data-input="order"]').value = order.slice(0, 20);
      }
    }
  }

  if (!customElements.get('track-order-form')) {
    customElements.define('track-order-form', TrackOrderForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-badges"] && !Shopify.designMode) return;
  try {
    
  /**
   * Counts the statistics up when the band first scrolls into view.
   *
   * Only the leading digits animate. "500k+", "2026" and "120+" all keep their
   * suffix throughout, so nothing reads as a wrong number mid-count — a year
   * ticking through 1,300 to 2,026 would look like a bug rather than a flourish.
   *
   * The final value is what renders from Liquid; script only rewinds it. If
   * this never runs, or the visitor has asked for reduced motion, the correct
   * number is already on screen.
   */
  class TrustStats extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      this.targets = Array.from(this.querySelectorAll('[data-count]'))
        .map((el) => {
          const match = el.textContent.trim().match(/^(\D*)(\d[\d,]*)(.*)$/);
          if (!match) return null;

          return {
            el,
            prefix: match[1],
            value: Number(match[2].replace(/,/g, '')),
            suffix: match[3],
            grouped: match[2].includes(','),
          };
        })
        .filter(Boolean);

      if (!this.targets.length) return;

      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          this.observer.disconnect();
          this.run();
        },
        { threshold: 0.35 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    run() {
      const DURATION = 1100;
      const start = performance.now();

      const step = (now) => {
        const t = Math.min((now - start) / DURATION, 1);
        // Ease-out cubic: fast off the mark, settling rather than stopping.
        const eased = 1 - Math.pow(1 - t, 3);

        this.targets.forEach((target) => {
          const current = Math.round(target.value * eased);
          const shown = target.grouped ? current.toLocaleString() : String(current);
          target.el.textContent = `${target.prefix}${shown}${target.suffix}`;
        });

        if (t < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    }
  }

  if (!customElements.get('trust-stats')) {
    customElements.define('trust-stats', TrustStats);
  }

  } catch(e) { console.error(e); }
})();
})();
